import React from "react"
import {
  StatusBadge,
  planButtonStyle as buttonStyle
} from "./PlanPrimitives"

export default function PlanQueueMobileList({
  cards,
  emptyLabel
}) {
  if (!cards.length) {
    return (
      <div
        style={{
          color: "#64748b",
          border: "1px dashed #e2e8f0",
          borderRadius: 16,
          padding: 18,
          background: "#f8fafc"
        }}
      >
        {emptyLabel}
      </div>
    )
  }

  return (
    <div style={{ display: "grid", gap: 12 }}>
      {cards.map((card) => (
        <div
          key={card.id}
          style={{
            border: `1px solid ${card.borderColor}`,
            background: "#ffffff",
            borderRadius: 18,
            padding: 14,
            display: "grid",
            gap: 12,
            boxShadow: "0 8px 22px rgba(15,23,42,0.05)"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 10,
              alignItems: "flex-start",
              flexWrap: "wrap"
            }}
          >
            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 900,
                  color: "#0f172a",
                  lineHeight: 1.2,
                  wordBreak: "break-word",
                  letterSpacing: "-0.02em"
                }}
              >
                {card.title}
              </div>

              <div
                style={{
                  marginTop: 6,
                  fontSize: 12.5,
                  color: "#64748b",
                  lineHeight: 1.4
                }}
              >
                {card.subtitle}
              </div>
            </div>

            <StatusBadge status={card.status} />
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
              gap: 10
            }}
          >
            <MobileMetric label="Saldo" value={card.pendingBalance} tone={card.pendingTone} />
            <MobileMetric label="Estimado" value={card.totalEstimated} />
          </div>

          <div
            style={{
              border: "1px solid #e2e8f0",
              background: "#f8fafc",
              borderRadius: 14,
              padding: 12,
              display: "grid",
              gap: 6
            }}
          >
            <div
              style={{
                fontSize: 11,
                fontWeight: 900,
                color: "#64748b",
                textTransform: "uppercase",
                letterSpacing: 0.4
              }}
            >
              Próximo paso
            </div>
            <div
              style={{
                fontSize: 14.5,
                fontWeight: 900,
                color: "#0f172a",
                lineHeight: 1.2
              }}
            >
              {card.nextActionTitle}
            </div>
            <div
              style={{
                fontSize: 12.5,
                color: "#475569",
                lineHeight: 1.4
              }}
            >
              {card.nextActionSubtitle}
            </div>
          </div>

          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <button
              onClick={card.onOpenPlan}
              style={{
                ...buttonStyle,
                background: "#ffffff"
              }}
            >
              Ver detalle
            </button>

            {card.onSchedule ? (
              <button
                onClick={card.onSchedule}
                style={{
                  ...buttonStyle,
                  background: "#eff6ff",
                  border: "1px solid #bfdbfe",
                  color: "#1d4ed8"
                }}
              >
                Agendar
              </button>
            ) : null}

            {card.onOpenPatient ? (
              <button
                onClick={card.onOpenPatient}
                style={{
                  ...buttonStyle,
                  background: "#f8fafc"
                }}
              >
                Paciente
              </button>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  )
}

function MobileMetric({ label, value, tone = "neutral" }) {
  const tones = {
    neutral: {
      bg: "#ffffff",
      border: "#e2e8f0",
      color: "#0f172a"
    },
    info: {
      bg: "#eff6ff",
      border: "#bfdbfe",
      color: "#1d4ed8"
    },
    warning: {
      bg: "#fffbeb",
      border: "#fde68a",
      color: "#92400e"
    },
    danger: {
      bg: "#fef2f2",
      border: "#fecaca",
      color: "#991b1b"
    },
    success: {
      bg: "#f0fdf4",
      border: "#bbf7d0",
      color: "#166534"
    }
  }

  const visual = tones[tone] || tones.neutral

  return (
    <div
      style={{
        border: `1px solid ${visual.border}`,
        background: visual.bg,
        borderRadius: 12,
        padding: 10
      }}
    >
      <div
        style={{
          fontSize: 11.5,
          color: "#64748b",
          fontWeight: 900,
          textTransform: "uppercase",
          letterSpacing: 0.25
        }}
      >
        {label}
      </div>

      <div
        style={{
          marginTop: 5,
          fontSize: 15,
          fontWeight: 900,
          color: visual.color,
          lineHeight: 1.15
        }}
      >
        {value}
      </div>
    </div>
  )
}